import type { ReactNode } from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { useEmbedContext } from '@/hooks/useEmbedContext';

export function ProtectedRoute({ children }: { children: ReactNode }) {
  const { isLoading, isAuthenticated } = useAuth();
  const { isEmbedded, embedError } = useEmbedContext();

  if (isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <div className="h-8 w-8 animate-spin rounded-full border-4 border-blue-500 border-t-transparent" />
      </div>
    );
  }

  if (!isAuthenticated) {
    if (isEmbedded) {
      return (
        <div className="flex min-h-screen items-center justify-center p-8">
          <div className="max-w-md text-center">
            <h1 className="mb-4 text-2xl font-bold">Authentication Failed</h1>
            <p className="text-gray-500">
              {embedError || 'Unable to authenticate with the parent portal. Please try reloading the page.'}
            </p>
          </div>
        </div>
      );
    }

    return (
      <div className="flex min-h-screen items-center justify-center p-8">
        <div className="max-w-md text-center">
          <h1 className="mb-4 text-2xl font-bold">UI Orchestrator</h1>
          <p className="text-gray-500">
            This application is designed to be accessed through the main
            portal. Please log in to the portal to access the UI Orchestrator.
          </p>
        </div>
      </div>
    );
  }

  return <>{children}</>;
}
